module.exports = __webpack_public_path__ + "img/banner-1-mobile.52041fad.png";